export default __webpack_public_path__ + "static/media/relative-mono-10-pitch-pro.ea8681a8.eot";